import { Asset } from '@/api/generatedApi';
import { MoveAssetModal } from '@/components/modals/MoveAssetModal/MoveAssetModal';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import { Button, IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { useState } from 'react';

export const MoveAssetButton = ({
  asset,
  variant = 'icon',
  size = 'small',
}: {
  asset: Asset;
  variant?: 'button' | 'icon';
  size?: IconButtonProps['size'];
}) => {
  const { permissions } = useGetCurrentUser();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!permissions.canCreateFolders) {
    return;
  }

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      {variant === 'button' ? (
        <Button onClick={handleClick} startIcon={<DriveFileMoveIcon />} size={size} sx={{ color: 'success.main' }}>
          Move
        </Button>
      ) : (
        <Tooltip title='Move asset'>
          <IconButton onClick={handleClick} size={size} sx={{ color: 'success.main' }}>
            <DriveFileMoveIcon sx={{ fontSize: '22px' }} />
          </IconButton>
        </Tooltip>
      )}
      <MoveAssetModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} asset={asset} />
    </>
  );
};
